module.exports = __webpack_public_path__ + "img/20190611_113036_003.7ee168fd.jpg";